/**
 * SSML Readme のセクション (タブ) 定義。
 *
 * ## 並び順が仕様である
 *
 * **先頭 = 初期表示** とし、「よく使われる事例」を先に置く。
 * 利用者は「こんな読み方にしたい」から探すため、構文カテゴリから始まる画面は
 * 「どのタグを使うか」を既に知っている人しか使えなかった。
 * 構文辞典は 2 番目に置き、事例から `relatedSyntax` を辿った先の
 * 詳細説明として機能させる。
 *
 * ## YAML 化のしやすさ
 *
 * キー / ラベル / 説明のフラットな構造のみで、他モジュール由来の値を持たない。
 * YAML へ移す場合は `sections:` としてそのまま書き出せる。
 */
import type { SsmlReadmeSection } from './types';

/** セクション一覧 (配列順がタブの並び順。先頭が初期表示) */
export const SSML_README_SECTIONS: readonly SsmlReadmeSection[] = [
  {
    section: 'use-cases',
    label: 'よく使われる事例',
    description:
      '「こんな読み方にしたい」から探すための入口です。課題 / 対策 / 利用 SSML / 期待効果 / 関連構文の順に並んでいます。タグで絞り込めます。',
  },
  {
    section: 'syntax',
    label: '構文辞典',
    description:
      'SSML タグをカテゴリ別に引くための辞典です。事例の「関連構文」で挙がったタグの詳しい説明を確認できます。',
  },
];

/** 既定で開くセクション (先頭 = よく使われる事例) */
export const DEFAULT_SSML_README_SECTION = SSML_README_SECTIONS[0].section;
